import React, { useState, useEffect } from 'react';
import Popup from '../common/popup/Popup';
import { Button, Form } from 'react-bootstrap';
import '../../styles/components/user/DeleteAccountPopup.css';

const DeleteAccountPopup = ({ show, onClose, onConfirm, isDeleting }) => {
  const [confirmationText, setConfirmationText] = useState('');
  const [buttonEnabled, setButtonEnabled] = useState(false);

  useEffect(() => {
    // Only enable the Delete button when the user has typed the exact word DELETE
    setButtonEnabled(confirmationText === 'DELETE');
  }, [confirmationText]);

  if (!show) return null;

  return (
    <Popup
      title="Confirm Account Deletion"
      onCancel={onClose}
      footer={
        <>
          <Button
            variant="danger"
            onClick={onConfirm}
            disabled={!buttonEnabled || isDeleting}
          >
            {isDeleting ? 'Deleting...' : 'Delete Account'}
          </Button>
          <Button variant="secondary" onClick={onClose} disabled={isDeleting}>
            Cancel
          </Button>
        </>
      }
    >
      <div className="delete-confirmation-body">
        <p>
          Are you absolutely sure you want to delete your account? This action
          <strong> cannot</strong> be undone.
        </p>
        <p>
          To confirm, please type <code>DELETE</code> in the box below.
        </p>
        <Form.Group controlId="confirmDeleteInput">
          <Form.Control
            type="text"
            placeholder="Type DELETE to confirm"
            value={confirmationText}
            onChange={e => setConfirmationText(e.target.value)}
            disabled={isDeleting}
          />
        </Form.Group>
      </div>
    </Popup>
  );
};

export default DeleteAccountPopup;
